<template>
  <a-select
    show-search
    optionFilterProp="label"
    v-model:value="inputValue"
    v-bind="$attrs"
    :options="orderedOptions"
  />
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    modelValue: {
      type: [String, Number, Array, null],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    }
  },

  emits: ['update:modelValue'],

  /**
   * Setup function for the select component.
   *
   * This function initializes the reactive properties `inputValue` and `orderedOptions`.
   * `inputValue` handles the two-way binding of the `modelValue` prop, emitting changes
   * back to the parent component. `orderedOptions` sorts the options array based on the
   * `label` property for display in the select component.
   *
   * @param {Object} props - The props passed to the component.
   * @param {Function} emit - The function to emit events to the parent component.
   * @returns {Object} - Returns the computed properties for the component.
   */
  setup(props, { emit }) {
    const inputValue = computed({
      get: () => props.modelValue,
      set: (value) => {
        emit('update:modelValue', value);
      }
    });

    const orderedOptions = computed(() =>
      [...props.options].sort((a, b) => a.label.localeCompare(b.label))
    );

    return { orderedOptions, inputValue };
  }
};
</script>
